<template>
    <div class="location-edit">
        <div class="title">
            <router-link to="/location/list"
                         tag="span">Location Mgt</router-link>
            <span>|</span>
            <el-button class="edit-btn"
                       type="info"
                       size="mini">{{
                id ? "Edit" : "Create"
            }}</el-button>
        </div>
        <div class="location-content">
            <el-form label-position="top"
                     ref="locationForm"
                     :rules="formRules"
                     :model="locationForm">
                <el-form-item label="Country:"
                              prop="countryId"
                              required>
                    <el-select v-model="locationForm.countryId"
                               placeholder="Please select country">
                        <el-option v-for="item in countryList"
                                   :label="item.nameEN"
                                   :value="item.id"
                                   :key="item.id">{{ item.nameEN }}
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Location Name:"
                              prop="name">
                    <el-input placeholder="1 to 100 characters"
                              v-model="locationForm.name"></el-input>
                </el-form-item>
                <el-form-item label="Address:"
                              prop="address">
                    <el-input type="textarea"
                              placeholder="Not over 500 characters."
                              v-model="locationForm.address"></el-input>
                </el-form-item>
                <el-form-item label="Mobile:"
                              prop="telephone"
                              required>
                    <el-input type="textarea"
                              placeholder="One number one line"
                              v-model="locationForm.telephone"></el-input>
                </el-form-item>
                <el-form-item label="Business Time:"
                              prop="openTimeEN"
                              required>
                    <el-input placeholder="Sample: Mon-Sun 9:00am-5:00pm(English version)"
                              v-model="locationForm.openTimeEN"
                              @click.native="showEditDialog('Business Time')"></el-input>
                </el-form-item>
                <el-form-item label="Location (longitude and latitude):">
                    <GmapMap v-if="locationData.center"
                             class="map_box"
                             ref="userMap"
                             :center="{
                            lat: locationData.center.lat,
                            lng: locationData.center.lng
                        }"
                             @click="mapClickEvent"
                             :zoom="6">
                        <gMapCluster v-if="locationData.locations">
                            <gMapMarker :position="{
                                    lat: parseFloat(locationData.locations.lat),
                                    lng: parseFloat(locationData.locations.lng)
                                }"
                                        :clickable="true"
                                        :draggable="true">
                            </gMapMarker>
                        </gMapCluster>
                    </GmapMap>
                </el-form-item>
                <el-form-item label="Longitude:"
                              prop="longitude"
                              required>
                    <el-input v-model="locationForm.longitude"></el-input>
                </el-form-item>
                <el-form-item label="Latitude:"
                              prop="latitude"
                              required>
                    <el-input v-model="locationForm.latitude"></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div class="sub-btn">
            <el-button class="subBtn"
                       :loading="submitLoading"
                       @click.prevent="updateOrAddLocation">Submit</el-button>
        </div>
        <el-dialog title="Multi-Language"
                   :visible.sync="editDialogVisible"
                   :closeOnClickModal="false"
                   width="50%">
            <div class="edit-title">{{ tag }}</div>
            <el-form :model="dialogForm"
                     label-position="top"
                     ref="dialogForm">
                <el-form-item label="English"
                              required
                              :rules="[{ required: true, message: tag + ' is required' }]"
                              prop="ENDia">
                    <el-input type="textarea"
                              v-model="dialogForm.ENDia"
                              :rows="3"></el-input>
                </el-form-item>
                <el-form-item label="Chinese"
                              required
                              :rules="[{ required: true, message: tag + ' is required' }]"
                              prop="CNDia">
                    <el-input type="textarea"
                              v-model="dialogForm.CNDia"
                              :rows="3"></el-input>
                </el-form-item>
                <el-form-item label="French"
                              required
                              :rules="[{ required: true, message: tag + ' is required' }]"
                              prop="FRDia">
                    <el-input type="textarea"
                              v-model="dialogForm.FRDia"
                              :rows="3"></el-input>
                </el-form-item>
                <el-form-item label="Arabic"
                              required
                              :rules="[{ required: true, message: tag + ' is required' }]"
                              prop="ARDia">
                    <el-input type="textarea"
                              v-model="dialogForm.ARDia"
                              :rows="3"></el-input>
                </el-form-item>
                 <el-form-item label="Urdu"
                              required
                              :rules="[{ required: true, message: tag + ' is required' }]"
                              prop="URDia">
                    <el-input type="textarea"
                              v-model="dialogForm.URDia"
                              :rows="3"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer"
                  class="dialog-footer">
                <el-button @click="cancelEdit">Cancel</el-button>
                <el-button type="primary"
                           @click="editDialog">Confirm</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import Vue from "vue";
import api from "@api/cooperation";
import Cookies from "js-cookie";
import { imgUrl } from "@config/common";
import * as VueGoogleMaps from "vue2-google-maps";
import gMapCluster from "vue2-google-maps/dist/components/cluster";
import gMapMarker from "vue2-google-maps/dist/components/marker";

Vue.use(VueGoogleMaps, {
    load: {
        //填入申请的apiKey账号
        key: "AIzaSyCeV4PKe5HsAfy6x2VB1Hf6fIeKE80B4Gs",
        libraries: ["places"],
        useBetaRenderer: false
        //            language: 'en'
    }
});

export default {
    data () {
        return {
            id: "",
            countryList: [],
            // 弹框相关
            dialogForm: {
                ENDia: "",
                CNDia: "",
                FRDia: "",
                ARDia: "",
                URDia: "",
            },
            tag: "",
            editDialogVisible: false,

            locationForm: {
                id: "",
                countryId: "",
                name: "",
                address: "",
                openTimeEN: "",
                openTimeCN: "",
                openTimeFR: "",
                openTimeAR: "",
                openTimeUR: "",
                telephone: "",
                longitude: "",
                latitude: ""
            },
            locationData: {
                locations: {},
                center: {
                    lat: 0,
                    lng: 0
                }
            },
            submitLoading: false,
            formRules: {
                name: [
                    {
                        required: true,
                        message: "Location Name is required",
                        trigger: "blur"
                    },
                    {
                        min: 1,
                        max: 100,
                        message: "1 to 100 characters.",
                        trigger: "blur"
                    }
                ],
                address: [
                    {
                        required: true,
                        message: "Address is required",
                        trigger: "blur"
                    },
                    {
                        min: 1,
                        max: 500,
                        message: "1 to 500 characters.",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    components: {
        gMapCluster,
        gMapMarker
    },
    mounted () {
        this.id = this.$route.query.id;
        this.setMapCenter();
        this.fetchCountryList();
        if (this.id) {
            this.fetchLocationDetail();
        }
    },
    methods: {
        setMapCenter () {
            //默认获取尼日利亚拉各斯经纬度
            this.locationData.center.lat = 6.499589;
            this.locationData.center.lng = 3.105983;
        },
        mapClickEvent (map) {
            console.log(map);
            this.locationData.locations.lat = map.latLng.lat();
            this.locationData.locations.lng = map.latLng.lng();
            this.locationForm.latitude = this.locationData.locations.lat;
            this.locationForm.longitude = this.locationData.locations.lng;
        },
        updateOrAddLocation () {
            if (this.id) {
                this.updateLocationById();
            } else {
                this.addLocation();
            }
        },
        async fetchLocationDetail () {
            let params = { locationId: this.id };
            const res = await api.queryLocationById(params);
            this.locationForm.address = res.data.address;
            this.locationForm.countryId = res.data.countryId;
            this.locationForm.createTime = res.data.createTime;
            this.locationForm.id = res.data.id;
            this.locationForm.latitude = res.data.latitude;
            this.locationForm.longitude = res.data.longitude;
            this.locationForm.name = res.data.name;
            this.locationForm.openTimeCN = res.data.openTimeCN;
            this.locationForm.openTimeEN = res.data.openTimeEN;
            this.locationForm.openTimeFR = res.data.openTimeFR;
            this.locationForm.openTimeAR = res.data.openTimeAR;
            this.locationForm.openTimeUR = res.data.openTimeUR;
            this.locationForm.telephone = res.data.telephone;
            this.locationData.center.lng = res.data.longitude;
            this.locationData.center.lat = res.data.latitude;
            this.locationData.locations.lng = res.data.longitude;
            this.locationData.locations.lat = res.data.latitude;
        },
        async updateLocationById () {
            this.$refs.locationForm.validate(async valid => {
                if (valid) {
                    let params = {
                        address: this.locationForm.address,
                        countryId: this.locationForm.countryId,
                        id: this.locationForm.id,
                        latitude: this.locationForm.latitude,
                        longitude: this.locationForm.longitude,
                        name: this.locationForm.name,
                        openTimeCN: this.locationForm.openTimeCN,
                        openTimeEN: this.locationForm.openTimeEN,
                        openTimeFR: this.locationForm.openTimeFR,
                        openTimeAR: this.locationForm.openTimeAR,
                        openTimeUR: this.locationForm.openTimeUR,
                        telephone: this.locationForm.telephone
                    };
                    this.submitLoading = true;
                    const res = await api.updateLocation(params);
                    this.submitLoading = false;
                    if (res.success) {
                        this.$message.success("Update location successfully");
                        this.$router.push({
                            name: "locationList",
                            params: { pageNo: this.$route.query.pageNo }
                        });
                    } else {
                        this.$message.error(res.error && res.error.message ? res.error.message : 'Service exception')
                    }
                }
            });
        },
        async addLocation () {
            this.$refs.locationForm.validate(async valid => {
                if (valid) {
                    let params = {
                        address: this.locationForm.address,
                        countryId: this.locationForm.countryId,
                        latitude: this.locationForm.latitude,
                        longitude: this.locationForm.longitude,
                        name: this.locationForm.name,
                        openTimeCN: this.locationForm.openTimeCN,
                        openTimeEN: this.locationForm.openTimeEN,
                        openTimeFR: this.locationForm.openTimeFR,
                        openTimeAR: this.locationForm.openTimeAR,
                        openTimeUR: this.locationForm.openTimeUR,
                        telephone: this.locationForm.telephone
                    };
                    this.submitLoading = true;
                    const res = await api.createLocation(params);
                    this.submitLoading = false;
                    if (res.success) {
                        this.$message.success("Add location successfully");
                        this.$router.push("/location/list");
                    } else {
                        this.$message.error(res.error && res.error.message ? res.error.message : 'Service exception')
                    }
                }
            });
        },
        async fetchCountryList () {
            const res = await api.queryAllCountryList();
            if (res.success == true) {
                this.countryList = res.data;
                this.countryIds = this.countryList.map(item => {
                    return item.id;
                });
            }
        },
        cancelEdit () {
            this.$refs.dialogForm.resetFields();
            this.dialogForm.CNDia = "";
            this.dialogForm.ENDia = "";
            this.dialogForm.FRDia = "";
            this.dialogForm.ARDia = "";
            this.dialogForm.URDia = "";
            this.editDialogVisible = false;
        },
        editDialog () {
            this.$refs.dialogForm.validate(valid => {
                if (valid) {
                    if (this.tag == "Business Time") {
                        this.locationForm.openTimeEN = this.dialogForm.ENDia;
                        this.locationForm.openTimeCN = this.dialogForm.CNDia;
                        this.locationForm.openTimeFR = this.dialogForm.FRDia;
                        this.locationForm.openTimeAR = this.dialogForm.ARDia;
                        this.locationForm.openTimeUR = this.dialogForm.URDia;
                    }
                    this.editDialogVisible = false;
                    this.$refs.dialogForm.resetFields();
                }
            });
        },
        showEditDialog (tag) {
            this.tag = tag;
            if (this.tag == "Business Time") {
                this.dialogForm.ENDia = this.locationForm.openTimeEN;
                this.dialogForm.CNDia = this.locationForm.openTimeCN;
                this.dialogForm.FRDia = this.locationForm.openTimeFR;
                this.dialogForm.ARDia = this.locationForm.openTimeAR;
                this.dialogForm.URDia = this.locationForm.openTimeUR;
            }
            this.editDialogVisible = true;
        }
    },
    computed: {
        headerOption () {
            return {
                version: "1.0.0",
                countryCode: "GH",
                lang: "en",
                token: Cookies.get("token")
            };
        }
    }
};
</script>
<style scoped>
.location-edit {
    margin-bottom: 20px;
    padding-top: 50px;
    margin-left: 270px;
}
.title {
    padding: 20px;
    border-bottom: 1px solid #e4e4e4;
}
.location-edit span {
    margin-right: 20px;
}
.location-edit .edit-btn {
    border-radius: 10px;
}
.location-content {
    padding-left: 20px;
    border-bottom: 1px solid #eee;
}
.location-operation {
    display: flex;
    align-items: center;
    color: rgb(70, 162, 255);
}
.location-operation span {
    margin-right: 10px;
}
.pagination {
    margin-left: 250px;
    text-align: center;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 20px;
}
.location-edit >>> .ql-editor {
    height: 200px;
}
.location-content >>> .el-upload__input {
    display: none;
}
.sub-btn {
    margin-top: 20px;
    padding-bottom: 20px;
    padding-left: 20px;
}
.subBtn {
    border: none;
    width: 130px;
    font-size: 22px;
    color: #fff;
    margin-top: 10px;
    background-color: #fe7b00;
    border-radius: 5px;
    box-shadow: 2px 2px 2px #ccc;
}
.edit-title {
    color: #66b1ff;
    font-weight: 600;
    font-size: 18px;
    margin-bottom: 10px;
}
.location-edit >>> .el-dialog__header {
    text-align: center;
    font-size: 18px;
    font-weight: 700;
    border-bottom: 1px solid #eee;
}
.location-edit >>> .el-dialog__footer {
    text-align: center;
}
.upload-demo {
    position: relative;
}
.upload-img {
    position: absolute;
    left: 0px;
    top: 0px;
    /* width: 100%;
    height: 100%; */
    z-index: 1000;
}
.map_box {
    height: 622px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/locationEdit.vue